import React from 'react';
import styles from './ArticleDetailPage.module.css';
import { HeroData } from './types';

interface HeroSectionProps {
    data: HeroData;
}

export const HeroSection: React.FC<HeroSectionProps> = ({ data }) => {
    const { titleParts, publishDate, backgroundColor = '#1a4d4d' } = data;

    return (
        <div className={styles.heroSection} style={{ backgroundColor }}>
            <div className={styles.heroContent}>
                <h1 className={styles.heroTitle}>
                    {titleParts.map((part, index) => (
                        <React.Fragment key={index}>
                            <span className={part.style === 'highlighted' ? styles.highlighted : ''}>
                                {part.text}
                            </span>
                            {index < titleParts.length - 1 && ' '}
                        </React.Fragment>
                    ))}
                </h1>
                <p className={styles.publishDate}>Published date: {publishDate}</p>
            </div>
        </div>
    );
};
